import { createElement, forwardRef, type HTMLAttributes } from 'react';
import { cn } from '../tokens/cn';
import type { VariantProps } from '../tokens/variants';
import { textVariants } from './text.variants';

type TextElement = 'p' | 'span' | 'div' | 'small' | 'strong' | 'em';

export interface TextProps
  extends Omit<HTMLAttributes<HTMLElement>, 'color'>,
    VariantProps<typeof textVariants> {
  as?: TextElement;
}

export const Text = forwardRef<HTMLElement, TextProps>(
  ({ className, size, weight, color, align, truncate, as = 'p', children, ...props }, ref) =>
    createElement(
      as,
      {
        ref,
        className: cn(textVariants({ size, weight, color, align, truncate }), className),
        ...props,
      },
      children,
    ),
);

Text.displayName = 'Text';
